import { rest } from '@0xtorch/core'
import { z } from 'zod'
import { fetchAllData } from '../../utils/fetchAllData'
import { okxApiEndpoint } from '../constants'
import { createPrivateGetHeaders } from '../utils'
import type { Trade } from './schema'
import { tradeSchema } from './schema'

const responseSchema = z.object({
  code: z.string(),
  msg: z.string(),
  data: z.array(tradeSchema),
})

type FetchAllSpotTradeHistoriesParameters = {
  readonly apiKey: string
  readonly apiSecret: string
  readonly password: string
  readonly from: number
  readonly to: number
  readonly proxy?: string
}

const last3MonthesUrlPath = '/api/v5/trade/fills-history'

// TODO 2年分のデータは別途 file 解析プログラムを作成

export const fetchAllSpotTradeHistories = async ({
  apiKey,
  apiSecret,
  password,
  from,
  to,
  proxy,
}: FetchAllSpotTradeHistoriesParameters): Promise<readonly Trade[]> => {
  const last3MonthesTs = Date.now() - 1000 * 60 * 60 * 24 * 90
  // ts <= last 3 month のデータ取得
  return await fetchAllData({
    from: Math.max(from, last3MonthesTs),
    to: Math.max(to, last3MonthesTs),
    limit: 100,
    desc: true,
    idKey: 'tradeId',
    timestampKey: 'ts',
    interval: 250,
    fetchData: async ({ from, to, limit, desc }) => {
      if (!desc) {
        throw new Error('desc must be true')
      }
      if (limit > 100) {
        throw new Error('limit must be less than or equal to 100')
      }

      const url = new URL(last3MonthesUrlPath, okxApiEndpoint)
      url.searchParams.append('instType', 'SPOT')
      url.searchParams.append('limit', limit.toString())
      url.searchParams.append('begin', from.toString())
      url.searchParams.append('end', to.toString())
      const query = url.searchParams.toString()

      const response = await rest(
        proxy === undefined
          ? url.toString()
          : `${proxy}${encodeURIComponent(url.toString())}`,
        {
          fetchOptions: {
            method: 'GET',
            headers: await createPrivateGetHeaders({
              apiKey,
              apiSecret,
              password,
              urlPath: url.pathname,
              query: query.length > 0 ? `?${query}` : '',
            }),
          },
          schema: responseSchema,
        },
      )

      return response.data
    },
  })
}
